import React from "react";
import api from "../../lib/api";

export default function AdminParticipants() {
  const [list, setList] = React.useState([]);

  React.useEffect(() => {
    const load = async () => {
      const sessions = await api.get("/admin/sessions").then(r => r.data);
      const all = [];
      for (const s of sessions) {
        const r = await api.get(`/admin/sessions/${s.id}/participants`);
        for (const p of r.data) {
          all.push({ ...p, session_date: s.date, session_heure: `${s.heure_debut}-${s.heure_fin}` });
        }
      }
      setList(all.sort((a,b) => (a.created_at < b.created_at ? 1 : -1)));
    };
    load();
  }, []);

  return (
    <div data-testid="admin-participants">
      <div className="eyebrow mb-2">Tous les participants</div>
      <h1 className="h-display text-4xl md:text-5xl">Participants.</h1>
      <div className="border border-white/10 mt-10 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-text-cream/50 eyebrow text-[0.65rem]">
            <tr>
              <th className="text-left p-4">Inscription</th>
              <th className="text-left p-4">Nom</th>
              <th className="text-left p-4">Email</th>
              <th className="text-left p-4">Session</th>
              <th className="text-left p-4">Paiement</th>
              <th className="text-left p-4">Statut</th>
            </tr>
          </thead>
          <tbody>
            {list.map(r => (
              <tr key={r.id} className="border-t border-white/5 font-light">
                <td className="p-4 text-text-cream/50 text-xs">{new Date(r.created_at).toLocaleDateString("fr-CH")}</td>
                <td className="p-4 font-serif">{r.prenom} {r.nom}</td>
                <td className="p-4 text-text-cream/70">{r.email}</td>
                <td className="p-4 text-text-cream/70">{r.session_date}<br/><span className="text-xs text-text-cream/40">{r.session_heure}</span></td>
                <td className="p-4">{r.type_paiement === "integral" ? "Intégral" : "Acompte"} · CHF {r.montant_paye}</td>
                <td className="p-4 capitalize">{r.statut}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={6} className="p-12 text-center italic text-text-cream/40">Aucun participant pour le moment.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
